/**
 * Shared theme constants
 * Used by PageEditorNew and PreviewModal
 */
import { ThemeSettings } from "../types";

/**
 * Default theme settings
 */
export const defaultTheme: ThemeSettings = {
  primary: "#3B82F6",
  secondary: "#10B981",
  font: "Sarabun",
};

/**
 * Theme presets for quick selection
 */
export const themePresets = [
  { name: "Ocean Blue", primary: "#3B82F6", secondary: "#06B6D4", font: "Sarabun", emoji: "🌊" },
  { name: "Forest Green", primary: "#059669", secondary: "#84CC16", font: "Sarabun", emoji: "🌿" },
  { name: "Royal Purple", primary: "#8B5CF6", secondary: "#EC4899", font: "Sarabun", emoji: "👑" },
  { name: "Sunset Orange", primary: "#F97316", secondary: "#FBBF24", font: "Sarabun", emoji: "🌅" },
  { name: "Rose Pink", primary: "#EC4899", secondary: "#F472B6", font: "Sarabun", emoji: "🌸" },
  { name: "Midnight", primary: "#1E293B", secondary: "#3B82F6", font: "Sarabun", emoji: "🌙" },
  { name: "Coral Reef", primary: "#F43F5E", secondary: "#FB7185", font: "Sarabun", emoji: "🐠" },
  { name: "Mint Fresh", primary: "#14B8A6", secondary: "#5EEAD4", font: "Sarabun", emoji: "🍃" },
];

/**
 * Color swatches for color picker
 */
export const colorSwatches = {
  primary: [
    "#3B82F6",
    "#2563EB",
    "#1D4ED8", // Blues
    "#059669",
    "#10B981",
    "#34D399", // Greens
    "#8B5CF6",
    "#7C3AED",
    "#6D28D9", // Purples
    "#EC4899",
    "#DB2777",
    "#BE185D", // Pinks
    "#F97316",
    "#EA580C",
    "#C2410C", // Oranges
    "#EF4444",
    "#DC2626",
    "#B91C1C", // Reds
    "#14B8A6",
    "#0D9488",
    "#0F766E", // Teals
    "#1E293B",
    "#334155",
    "#475569", // Slates
  ],
  secondary: [
    "#06B6D4",
    "#22D3EE",
    "#67E8F9", // Cyans
    "#84CC16",
    "#A3E635",
    "#BEF264", // Limes
    "#FBBF24",
    "#FCD34D",
    "#FDE68A", // Ambers
    "#F472B6",
    "#F9A8D4",
    "#FBCFE8", // Pinks
    "#A78BFA",
    "#C4B5FD",
    "#DDD6FE", // Violets
    "#5EEAD4",
    "#99F6E4",
    "#CCFBF1", // Teals
  ],
};

/**
 * Font options with Thai support
 */
export const fontOptions = [
  { name: "Sarabun", label: "Sarabun (ไทย)", sample: "สวัสดี Hello" },
  { name: "Prompt", label: "Prompt (ไทย)", sample: "สวัสดี Hello" },
  { name: "Kanit", label: "Kanit (ไทย)", sample: "สวัสดี Hello" },
  { name: "Fahkwang", label: "Fahkwang (ไทย)", sample: "สวัสดี Hello" },
  { name: "Noto Sans Thai", label: "Noto Sans (ไทย)", sample: "สวัสดี Hello" },
  { name: "Inter", label: "Inter", sample: "Hello World" },
  { name: "Poppins", label: "Poppins", sample: "Hello World" },
];
